import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { createOpenFormModalAction } from "@multiweb/reactCore/bridge";
import { IAttrValue } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createToggleEditDialogsVisibilityAction } from "../../../actions";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";
import { TextLOVEditComponent, TextLOVEditComponentProps } from "./TextLOVEditComponent";
import { createOnTextLOVEditClick } from "./utils";

type TextLOVEditProps = {
    readonly formName: string;
    readonly attributeNames: readonly string[];
    readonly onFormClose: (results?: readonly IAttrValue[]) => void;
    readonly condition?: string;
} & Omit<TextLOVEditComponentProps, "onClick"> & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadOnly: boolean;
};

const mapStateToProps: MapStateToProps<StateProps, TextLOVEditProps, IAppState> = (state, { hostKey }) => ({
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
});

type DispatchProps = {
    openFormModal: typeof createOpenFormModalAction;
    toggleEditDialogsVisibility: () => void;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, TextLOVEditProps> = (dispatch, { hostKey }) => ({
    toggleEditDialogsVisibility: () => dispatch(createToggleEditDialogsVisibilityAction(hostKey)),
    openFormModal: (params) => dispatch(createOpenFormModalAction(params)),
});

const mergeProps: MergeProps<StateProps, DispatchProps, TextLOVEditProps, TextLOVEditComponentProps> = (
    { isWorkflowReadOnly },
    { openFormModal, toggleEditDialogsVisibility },
    { attributeNames, formName, onFormClose, condition, maxLength, hostKey, value, isEditable, onChange, readOnly, required, qa }) => ({
    hostKey,
    value,
    isEditable,
    onChange,
    required,
    maxLength,
    qa,
    readOnly: isWorkflowReadOnly || readOnly,
    onClick: createOnTextLOVEditClick(toggleEditDialogsVisibility, openFormModal, onFormClose, formName, attributeNames, condition),
});

export const TextLOVEdit = connect(mapStateToProps, mapDispatchToProps, mergeProps)(TextLOVEditComponent);
